<template>
    <div class="contentBox rechargePage">
        <div class="pageTitle">
            <h1>购买充值</h1>
        </div>
        <el-row class="comboWrap">
            <!--<div class="comboMainSec">-->
            <template v-for="item in rechargePackages">
                <el-col :span="12" :key="item.packageId">
                    <div :class="item.containerClass">
                        <img src="../../../assets/superLogo.svg" alt="" class="normalLogo" v-if="item.e">
                        <img src="../../../assets/normalLogo.svg" alt="" class="normalLogo" v-else>
                        <div class="comboText comboText2" v-if="item.e">{{item.name}}</div><div class="comboText comboText1" v-else>{{item.name}}</div>
                        <div :class="item.tableClass">
                            <div class="comboBox">
                                <div class="content1">流量</div>
                                <div class="content2">{{item.formatFlow}}</div>
                            </div>
                            <div class="comboBox">
                                <div class="content1">空间</div>
                                <div class="content2">{{item.formatSpace}}</div>
                            </div>
                            <div class="comboBox">
                                <div class="content1">时长</div>
                                <div class="content2">{{item.formatDuration}}</div>
                            </div>
                        </div>
                        <div class="comboPrice comboPrice2" v-if="item.e">￥ {{item.price}}</div><div class="comboPrice comboPrice1" v-else>￥ {{item.price}}</div>
                        <div class="buyToget buyToget2" v-if="item.e" @click="buy(item)">购买</div><div class="buyToget buyToget1" @click="buy(item)" v-else>购买</div>
                    </div>
                </el-col>
            </template>
        </el-row>
        <p class="tips">没有找到合适的套餐，请和我们联系，为您定制您的专属套餐。</p>
        <el-popover
                placement="right"
                width="400"
                trigger="click">
            <p><i class="el-icon-phone"></i>021-55239116</p>
            <p><i class="el-icon-message"></i>service@fortune-net.cn</p>
            <el-button slot="reference">查看联系方式</el-button>
        </el-popover>
    </div>
</template>

<script>
    import common from '../../../common.vue';

    export default {
        name: "Recharge",
        data() {
            return {
                rechargePackages: [],
                howWidth: 12,
            };
        },
        methods: {
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            /**
             * 获取套餐列表
             */
            getPackages(){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/rPackage/packageList').then(function (res) {
                    let r = res.data;
                    if (r.code === 0 && r.data){
                        //_this.rechargePackages = r.data;
                        _this.formatPackages(r.data);
                    }
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                });
            },

            /**
             * 格式化套餐，并显示
             * @param packages
             */
            formatPackages(packages){
                let _this = this;
                _this.rechargePackages = [];
                (packages || []).forEach(function(item){
                    // 是否显示为金色
                   item.e = (item.price > 5);
                   item.containerClass = item.e? 'combo2Main comboMain': 'combo1Main comboMain';
                   item.tableClass = item.e? 'comboTable comboTable2': 'comboTable comboTable1';
                   // 流量
                    item.formatFlow = Math.round(item.flow / 1024 / 1024 / 1024) + ' G';
                    // 空间
                    item.formatSpace = Math.round(item.space / 1024 / 1024 / 1024) + ' G';
                    // 时长
                    item.formatDuration = Math.round(item.duration / 3600) + ' H';
                   _this.rechargePackages.push(item);
                });
            },

            /**
             * 购买套餐
             * @param p 套餐对象
             */
            buy(p){
                console.info(p.packageId);
                this.$router.push({
                    path: '/finance/number',
                    name: 'Number',
                    params: { pid: p.packageId }
                });
            }
        },
        mounted() {
            this.getPackages();
        }
    };
</script> 

<style lang="less">
.rechargePage {
    width: 824px;
}

.pageTitle {
    margin-bottom: 20px;

    h1 {
        height: 20px;
        line-height: 24px;
    }
}

.comboWrap {
    width: 824px;
    /*height: 647px;*/
    background: #ffffff;
    border: 1px solid #e8e8e8;
    padding: 20px 30px;
    position: relative;
    overflow: hidden;
    .comboMainSec{
        height:486px;
    }

    .comboMain {
        width: 360px;
        height: 486px;
        background: linear-gradient(136deg, #4C4C4C 0%, #1F262B 100%);
        border-radius: 10px;
        display: flex;
        align-items: center;
        flex-direction: column;
        float: left;
        padding-top: 40px;
        margin-top: 20px;

        .comboText {
            height: 56px;
            font-size: 40px;
            font-family: DIN Alternate;
            font-weight: bold;
            line-height: 56px;
            color: #FAFAFA;
            text-align: center;
            margin: 11px 0 19px;
        }

        .comboText2 {
            color: #402201;
        }

        .comboPrice {
            height: 67px;
            font-size: 48px;
            font-family: DIN Alternate;
            font-weight: bold;
            line-height: 67px;
            color: #FAFAFA;
            text-align: center;
            margin: 20px auto;
        }

        .comboPrice2 {
            color: #402201;
        }

        .buyToget {
            width: 360px;
            height: 60px;
            background: #202326;
            border-radius: 0px 0px 6px 6px;
            font-size: 26px;
            font-family: Microsoft YaHei;
            line-height: 60px;
            color: #FFFFFF;
            text-align: center;
            cursor: pointer;
        }

        .buyToget:hover {
            background: #000000;
            color: #FFFFFF;
        }

        .buyToget2 {
            background: #DBB36E;
            color: #402201;
        }

        .buyToget2:hover {
            background: #C78E2C;
            color: #FFFFFF;
        }
    }

    .combo1Main {
        margin-right: 37px;
    }

    .combo2Main {
        background: linear-gradient(137deg, #F3DAAF 0%, #EABE71 100%);
    }

    .comboTable {
        width: 239px;

        .comboBox {
            width: 239px;
            height: 35px;
            display: flex;
            border-left: 1px solid #515658;
            border-top: 1px solid #515658;
            color: #FAFAFA;

            .content1 {
                width: 25%;
                height: 35px;
                line-height: 35px;
                text-align: center;
                border-right: 1px solid #515658;
                border-bottom: 1px solid #515658;
                font-size: 14px;
                color: #FAFAFA;
            }

            .content2 {
                width: 75%;
                height: 35px;
                line-height: 35px;
                padding-left: 18px;
                border-right: 1px solid #515658;
                border-bottom: 1px solid #515658;
                font-size: 14px;
                color: #FAFAFA;
            }
        }
    }

    .comboTable2 {
        .comboBox {
            border-left: 1px solid #D4AD6A;
            border-top: 1px solid #D4AD6A;

            .content1 {
                color: #402201;
                border-right: 1px solid #D4AD6A;
                border-bottom: 1px solid #D4AD6A;
            }

            .content2 {
                color: #402201;
                border-right: 1px solid #D4AD6A;
                border-bottom: 1px solid #D4AD6A;
            }
        }

    }
}
.tips {
    font-size: 14px;
    font-weight: 400;
    color: #909399;
    margin-top: 36px;
    margin-bottom: 16px;
}

.contact {
    width: 130px;
    height: 40px;
    background: #306ff6;
    opacity: 1;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
}

.contact:hover {
    background: #4aa3f8;
}
</style>